const FormLabel = {
  baseStyle: {
    mb: "4px",
    fontWeight: 600,
  },
};

export default FormLabel;